'use strict';

// ---------- Reemplazo mínimo de events.EventEmitter de Node ----------
//
// El código original (flow-engine.js, duplex-linea.js) usa la clase
// EventEmitter de Node solo para on/off/emit. El navegador no la trae, así
// que esta clase chica cubre exactamente esa superficie y nada más, para
// poder portar el resto del código sin tocarle la lógica.

export class TinyEmitter {
  constructor() {
    this._listeners = new Map();
  }

  on(event, fn) {
    if (!this._listeners.has(event)) this._listeners.set(event, new Set());
    this._listeners.get(event).add(fn);
    return this;
  }

  off(event, fn) {
    const set = this._listeners.get(event);
    if (set) set.delete(fn);
    return this;
  }

  once(event, fn) {
    const wrapper = (...args) => {
      this.off(event, wrapper);
      fn(...args);
    };
    return this.on(event, wrapper);
  }

  emit(event, ...args) {
    const set = this._listeners.get(event);
    if (!set || set.size === 0) return false;
    // Copia: un listener puede desuscribirse a sí mismo durante el emit.
    for (const fn of Array.from(set)) fn(...args);
    return true;
  }
}
